import { Component, Inject } from '@angular/core';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ITag, ITagUpdatePayload } from '../taguri-proiecte.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TaguriProiecteService } from '../taguri-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-edit-taguri-proiecte',
    templateUrl: './edit-taguri-proiecte.component.html',
    styleUrls: ['./edit-taguri-proiecte.component.scss']
})
export class EditTaguriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ITag,
        private dialogRef: MatDialogRef<EditTaguriProiecteComponent>,
        private taguriProiecteService: TaguriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as ITag;
        const payload: ITagUpdatePayload = {
            id: this.data.id,
            name,
        };

        this.taguriProiecteService
            .updateTag(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
